<template>
  <div class="shortcuts">
    <div class="shortcuts__content">
      <h1>Shortcuts</h1>
      <ol>
        <li><code>Ctrl/Cmd</code> + <code>/</code> - Show/Hide shortcuts</li>
        <li><code>Shift</code> + <code>Tab</code> - Show/Hide sidebar</li>
        <li><code class="mouse">Doubleclick</code> @ <code class="special">action_cell</code> - Go to edit</li>
      </ol>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Shortcuts',
};
</script>

<style lang="scss" scoped>
.shortcuts {
  &:before {
    content: '';
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    height: 100%;
    bottom: 0;
    z-index: 1;
    background-color: rgba(0, 0, 0, 0.4);
  }

  h1 {
    position: absolute;
    top: -70px;
    left: 0;
    right: 0;
    text-align: center;
    text-shadow: 0 2px 2px rgba(0, 0, 0, 0.4);
  }

  .shortcuts__content {
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    background-color: rgba(0, 0, 0, 0.6);
    width: 50vw;
    height: 50vh;
    border-radius: 6px;
    column-count: 2;
    color: #fff;
    z-index: 2;
    padding: 40px;
    font-size: 0.8em;

    ol {
      margin: 0;
      list-style-type: none;
      padding-left: 0;
      li {
        padding-top: 5px;
        padding-bottom: 5px;
      }
    }
  }

  code {
    background-color: rgba(0, 0, 0, 0.6);
    padding: 6px 10px;
    display: inline-block;
    border-radius: 3px;
    &.mouse {
      background-color: rgba(19, 168, 94, 0.6);
    }
    &.special {
      background-color: rgba(109, 158, 161, 0.6);
    }
  }
}
</style>
